import type { LocaleDictionary } from "~/i18n/types";

// Dictionary specific to ChatStreamPage
export type ChatPageMessages = {
  norway_image_description: string;
  agreement_prefix: string;
  terms: string;
  and: string;
  privacy_policy: string;
};

export const chatPageDictionary: LocaleDictionary<ChatPageMessages> = {
  en: {
    norway_image_description: "Enjoy this image of Norway.",
    agreement_prefix: "By messaging Storytell, you agree to our",
    terms: "Terms",
    and: "and",
    privacy_policy: "Privacy Policy",
  },
  es: {
    norway_image_description: "Disfruta de esta imagen de Noruega.",
    agreement_prefix: "Al enviar mensajes a Storytell, aceptas nuestros",
    terms: "Términos",
    and: "y",
    privacy_policy: "Política de Privacidad",
  },
  fr: {
    norway_image_description: "Profitez de cette image de la Norvège.",
    agreement_prefix: "En envoyant des messages à Storytell, vous acceptez nos",
    terms: "Conditions",
    and: "et",
    privacy_policy: "Politique de Confidentialité",
  },
  de: {
    norway_image_description: "Genießen Sie dieses Bild von Norwegen.",
    agreement_prefix: "Durch das Senden von Nachrichten an Storytell stimmen Sie unseren",
    terms: "Bedingungen",
    and: "und",
    privacy_policy: "Datenschutzrichtlinie",
  },
  ja: {
    norway_image_description: "このノルウェーの画像をお楽しみください。",
    agreement_prefix: "Storytellにメッセージを送信することで、私たちの",
    terms: "利用規約",
    and: "と",
    privacy_policy: "プライバシーポリシー",
  },
  leet: {
    norway_image_description: "3nj0y 7h15 1m493 0f N0rw4y.",
    agreement_prefix: "6y m355491n9 570ry7311, y0u 49r33 70 0ur",
    terms: "73rm5",
    and: "4nd",
    privacy_policy: "Pr1v4cy P011cy",
  },
};
